import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { ticketingService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { TicketColumns } from 'components/common/enhanced/common-headers';

export const TechnicianCreatedTickets = () => {
  const translationPrefix = 'pages.tickets';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = TicketColumns(false, null);
  columns.splice(7, 1);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.technician-created`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <EnhancedDataGrid
          columns={columns}
          service={ticketingService}
          getMethod={ticketingService.getTechnicianCreated}
          refresh={datagridRefresh}
          disableDelete
        />
      </TenantPage>
    </>
  );
};

export default TechnicianCreatedTickets;
